
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { post, get } from '../../../helpers/api_helper';
import { POST_UPDATE_SETTING, GET_ALL_SETTING } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import useMounted from '../../../hooks/useMounted';
import { IsModemAccess } from '../../../helpers/Helper';
import Loader from '../../../components/Loader';

const Setting = (props) => {
    const navigate = useNavigate();


    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState();


    useMounted(() => {
        if (!IsModemAccess('setting', 'edit')) {
            toast.error('Does not permission this module');
            navigate("/admin/dashboard");
        }
        async function get_detaile() {
            await get_app_setting();
            setLoader(1);
        }
        get_detaile();
    }, [])


    const get_app_setting = async () => {
        var res_data = await get(GET_ALL_SETTING + "?type=invoice-setting");
        if (res_data.status) {
            await setInputs(res_data.data);
        } else {
            toast.error(res_data.message);
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();

        SetButtonDisabled(true);
        var res_data = await post(POST_UPDATE_SETTING, form_inputs, {});
        if (res_data.status) {
            await get_app_setting();
            toast(res_data.message);
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

    // input text change handler
    const handleInputChange = (event) => {
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Invoice Setting</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Brand Name</label>
                                    <input name="invoice_brand_name" value={form_inputs.invoice_brand_name} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Business Name</label>
                                    <input name="invoice_business_name" value={form_inputs.invoice_business_name} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Address</label>
                                    <input name="invoice_address" value={form_inputs.invoice_address} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Email Address</label>
                                    <input name="invoice_email_address" value={form_inputs.invoice_email_address} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Tax Info</label>
                                    <input name="invoice_tax_info" value={form_inputs.invoice_tax_info} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Note</label>
                                    <input name="invoice_note" value={form_inputs.invoice_note} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                
                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Update
                                    </button>
                                    <Link to="/admin/setting" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;